<div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" >Note</h5>
        <button type="button" class="close" aria-label="Chiudi" (click)="closeModal()">
          <span class="font-24" aria-hidden="true">&times;</span>
        </button>      
    </div>
      <div class="modal-body">
            <div class="col-lg-12">
              <div *ngIf="hasPrecedente" >
                <label>Note {{tipoNotePrecedente}}</label>
                <textarea class="form-control" readonly [(ngModel)]="notePrecedenti" rows="5" cols="5"></textarea>
              </div>
              <div>
                <label>Note {{tipoNote}}</label>
                <textarea class="form-control" [(ngModel)]="note" rows="5" cols="5"></textarea>
              </div>
                
            </div>
      </div>
      <div class="modal-footer">
        <button *ngIf="tipoNote != 'In Lavorazione'" type="button" class="btn btn-info ml-auto" (click)="save()"><span class="pl-1 text-white">{{tipoNote}}</span></button>
        <button *ngIf="tipoNote == 'In Lavorazione'" type="button" class="btn btn-info ml-auto" (click)="save()"><span class="pl-1 text-white">Salva</span></button>
      </div>
    </div>
  </div>
